import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Dashboard from './DashBoard/Dashboard';
import SignIn from './SignIn/Sign';
import ProtectedRoute from './ProtectedRouter/ProtectedRouter';
import { AuthProvider, useAuth } from './Auth/AuthProtecter';
import Backdropcircle from "./Loading/Backdrop";
import NotFound from "./NotFound/NotFound";

export default function App() {
    const auth = useAuth();
    const [isBackdropVisible, setIsBackdropVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setIsBackdropVisible(false), 1000);
        return () => clearTimeout(timer); // Limpieza para evitar posibles fugas de memoria
    }, []);

    return (
        <AuthProvider>
            {isBackdropVisible ? (
                <Backdropcircle />
            ) : (
                <Router basename="/appointment">
                    <Routes>
                        <Route path="*" element={<NotFound />} />
                        <Route path="/signin" element={<SignIn />} />
                        <Route
                            path="/application"
                            element={
                                <ProtectedRoute isAuthenticated={auth.isAuthenticated}>
                                    <Dashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/" element={<Navigate to="/signin" />} />
                    </Routes>
                </Router>
            )}
        </AuthProvider>
    );
}
